<template>
  <div class="bubble-box sc-message--file" v-ripple role="button" v-on:click="clicked" :id="message.id">

    <v-layout align-center style="padding:5px 0;">
      <v-icon large style="margin-left:-4px;">description</v-icon>

      <v-layout column>
        <div style="vertical-align: middle;">
          <span class="sc-message--file-title">{{filename}}</span>
          <v-icon small class="sc-message--file-icon" v-if="hasTimerIcon">{{timerIcon}}</v-icon>
        </div>
        <span class="sc-message--file-size">{{size}}</span>
      </v-layout>
    </v-layout>

    <div class="sc-message--file-state">
      <div class="inner-state">
        <MessageState :state="state" :time="time" />
      </div>
    </div>

  </div>
</template>

<script>
  import MessageState from './MessageState.vue'
  import timeUtils from '@utils/timeUtils'

  export default {
    components: {
      MessageState
    },
    props: {
      message: {
        type: Object,
        required: true
      }
    },
    computed: {
      filename() {
        return this.message.data.name
      },
      time() {
        return timeUtils.getShortTime(this.message.time);
      },
      state() {
        return this.message.sent ? this.message.state : null
      },
      size() {
        const mb = this.message.data.size / 1000000
        return mb.toFixed(2) + ' MB'
      },
      timerIcon() {
        return this.message.state == this.states.MessageRead ? 'history' : 'visibility'
      },
      hasTimerIcon() {
        return this.message.data.ttl >= 0 && !this.message.sent
      },
    },
    methods: {
      clicked() {
        const filePath = this.message.content
        this.$store.dispatch('openFileAsTemporary', filePath).then(result => {
          // TODO: inform user about fail if happen
          console.log('openFileAsTemporary', result)
        })
      }
    }
  }
</script>

<style>
  .sc-message--file {
    opacity:1;
    border-radius: inherit;
  }
  .sc-message--file:hover {
    opacity:0.8;
  }

  .sc-message--file-state .inner-state {
    /* align to the same position with text message state */
    margin-left: 16px;
    margin-bottom: 6px;
  }
  .sc-message--file-size {
    font-size: 85%;
    color:var(--v-alternativeBackground-base);
  }
  .sc-message--file-icon {
    font-size: 85%;
  }
</style>
